import React, { useState } from 'react'
import ToggleCard from '../../theme/cards/ToggleCard';
import TelephoneNumber from '../TelephoneNumber';

function HowThisWorksCard() {



    return (

        <div className=''>
            <ToggleCard 
                title="Not sure what comes next? Here's the process to get funded on CleanFi:" 
                topLevelClass="has-background-success-light"
            >
                <div className='mb-2'>
                    <div>
                        <span className='has-text-weight-semibold has-text-primary mr-2'>Step 1: Pick the right financing option</span>
                        <span className='is-italic has-text-light-grey is-size-7'>takes minutes to hours, depending on how long you need to review your options</span>
                    </div>
                    Click  “Share All Options” at the top of the page to forward it to the client. Read the notes and look-up <a href="https://blog.cleanfi.com/choosing-the-right-option/">Choosing The Right Option. </a>
                    Or, if you have a <a href="https://blog.cleanfi.com/conditional_contract/">signed conditional sales contract</a>, introduce the property owner to the CleanFi team,
                    and we will do all the qualifying work to move the project forward.
                </div>
                <div className='mb-2'>
                    <div>
                        <span className='has-text-weight-semibold has-text-primary mr-2'>Step 2:  Apply</span>
                        <span className='is-italic has-text-light-grey is-size-7'>30 minutes if you have your corporate docs handy</span>
                    </div>
                    Answer Yes to all qualifying questions, upload all required documents, pay the application fee (varies between $95 and $250 and is stated at the top of the application) and electronically sign the application.
                </div>
                <div className='mb-2'>
                    <div>
                        <span className='has-text-weight-semibold has-text-primary mr-2'>Step 3: App goes to Funders</span>
                        <span className='is-italic has-text-light-grey is-size-7'>1-4 business days</span>
                    </div>
                    CleanFi pre-underwrites the application - returns notes and suggestions, if any, on the information presented. Then the underwriter for that product reviews the file.  Additional documents or information may be needed.
                    Underwriting can take from 2 days to several weeks, depending on the financing mechanism, the complexity of the transaction, and the responsiveness of the Applicant. Loans secured by a personal guarantee are the fastest. CPACE loans take the longest.
                    Once the underwriting is complete, the lender presents funding documents.

                </div>
                <div className='mb-2'>
                    <div>
                        <span className='has-text-weight-semibold has-text-primary mr-2'>Step 4: Fund</span>
                        {/* <span className='is-italic has-text-light-grey is-size-7'>A few minutes</span> */}
                    </div>
                    In some cases, the lender may ask for additional information. Once the underwriting is complete, the lender will send you a loan agreement to sign.
                </div>
               
            </ToggleCard>
        </div>
    )

}


export default HowThisWorksCard;

// <div className='card my-4'>
//     <div className='header mb-2'>

//     </div>
//     <div className='card-content'>
//         <div className='is-italic has-text-grey-bis'> First time here?</div>
//         <div className="is-flex  is-fullwidth r">
//             <div className='title is-size-4 has-text-primary'>
//                 The four steps to getting financed on CleanFi
//             </div>
//             <div className='pl-6'>
//                 <span>
//                     Expand
//                     <i className="ml-4 fas fa-arrow-right"/>
//                 </span>
//             </div>
//         </div>
//     </div>